// import 'vue-event-calendar/dist/style.css' //^1.1.10, CSS has been extracted as one file, so you can easily update it.
import 'quill-mention/dist/quill.mention.css';
import 'v-calendar/dist/style.css';
import './modules/slack/main.css';
// import vueEventCalendar from 'vue-event-calendar'
import FlatPickr from 'vue-flatpickr-component';
// import * as VueQuillEditor from '@vueup/vue-quill'
// import {Quill} from "@vueup/vue-quill";
import Oruga from '@oruga-ui/oruga-next';
import { bulmaConfig } from '@oruga-ui/theme-bulma';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import moment from "moment";
import 'sweetalert2/dist/sweetalert2.min.css';
import { createApp } from 'vue';
import * as VueRouter from 'vue-router';
import VueSweetalert2 from 'vue-sweetalert2';
// import VueGapi from 'vue-gapi'
import vue3GoogleLogin from 'vue3-google-login';

import axios from "axios";
import "dotenv/config";
import Echo from 'laravel-echo';
import VCalendar from "v-calendar";
import { mapActions, mapGetters } from 'vuex';
import CustomDialog from './components/modals/CustomDialog';
import filters from './filters';

import autocompleteselect from './components/AutocompleteSelect';
import bquill from './components/BQuill';
import contenteditable from './components/ContentEditable';
import dropdownquickedit from './components/DropdownQuickEdit';
import formerror from './components/FormError';
import contactmodal from './components/modals/Contact';
import customviewmodal from './components/modals/CustomView';
import filesendmodal from './components/modals/FileSend';
import remindermodal from './components/modals/Reminder';
import replymodal from './components/modals/Reply';
import signaturesModal from './components/modals/Signatures';
import tablesettingsmodal from './components/modals/TableSettings';
import timelogmodal from './components/modals/TimeLog';
import multicomplete from './components/Multicomplete';

window.Pusher = require('pusher-js');

window.echo = new Echo({
    broadcaster: 'pusher',
    key: Laravel.env.PUSHER_APP_KEY,
    cluster: Laravel.env.PUSHER_APP_CLUSTER,
    forceTLS: true
})

console.log(UPLOADCARE_PUBLIC_KEY)

window.Vue = createApp({
    computed: {
        ...mapGetters(['currentUserId']),
    },

    created() {
        this.processPresetUserData()
    },

    mounted() {
        echo.private('App.Models.User.' + this.currentUserId)
            .notification(() => {
                this.fetchUnreadLatest5Notifications()
            })
    },

    watch: {
        currentUserId(value) {
            if (value) {
                this.hydrateApp()
                // todo optimize this

                /**
                 paginate:
                 contacts
                 files

                 paginated:
                 tasks
                 */
            }
        }
    },

    methods: {
        ...mapActions([
            'hydrateApp',
            'processPresetUserData',
            'fetchTasks',
            'fetchFiles',
            'fetchUnreadLatest5Notifications'
        ])
    }
})


Vue.component('table-settings-modal', tablesettingsmodal)
Vue.component('custom-view-modal', customviewmodal)
Vue.component('reminder-modal', remindermodal)
Vue.component('signatures-modal', signaturesModal)
Vue.component('reply-modal', replymodal)
Vue.component('time-log-modal', timelogmodal)
Vue.component('file-send-modal', filesendmodal)
Vue.component('contact-modal', contactmodal)
Vue.component('form-error', formerror)
Vue.component('content-editable', contenteditable)
Vue.component('dropdown-quick-edit', dropdownquickedit)
Vue.component('autocomplete-select', autocompleteselect)
Vue.component('b-quill', bquill)
Vue.component('multicomplete', multicomplete)


// const bugsnag = require('bugsnag-js')
// const bugsnagClient = bugsnag({ apiKey: Laravel.env.BUGSNAG_API_KEY, releaseStage: ENVIRONMENT })
// const bugsnagVue = require('bugsnag-vue')
//
// bugsnagClient.use(bugsnagVue(Vue))

// shim for localStorage
if (window.localStorage === undefined) {
    window.localStorage = { setItem() { }, getItem() { } }
}

_.mixin({
    /**
     * converts an object to a query string
     * name borrowed from jQuery
     * @param obj
     * @returns {string}
     */
    param(obj) {
        return _.map(
            _.pickBy(obj, v => !!v),
            (v, k) => encodeURIComponent(k) + '=' + encodeURIComponent(v)
        ).join('&')
    }
})






// Quill.register({
//     'modules/mention': mention
// });

const {
    EMAILS_GMAIL_API_KEY,
    EMAILS_GMAIL_CLIENT_ID,
    EMAILS_GMAIL_SCOPES,
} = Laravel.env.EMAILS


// Vue.use(VueGapi, {
//     apiKey: EMAILS_GMAIL_API_KEY,
//     clientId: EMAILS_GMAIL_CLIENT_ID,
//     discoveryDocs: [
//         "https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest",
//         "https://www.googleapis.com/discovery/v1/apis/people/v1/rest",
//     ],
//     scope: EMAILS_GMAIL_SCOPES,
// })

Vue.use(vue3GoogleLogin, {
    clientId: EMAILS_GMAIL_CLIENT_ID
})

// Vue.use(vueEventCalendar, {locale: 'en'})
Vue.use(VCalendar, {})
Vue.use('QuillEditor', QuillEditor)
Vue.use(FlatPickr)
Vue.use(VueRouter)
Vue.use(Oruga, bulmaConfig)
Vue.use(VueSweetalert2);
require('./components/panel')
require('./components/dropdown')
require('./components/pagination')
require('./components/table')
require('./components/menu')
require('./directives')

const NoticeDuration = 4000

Vue.mixin({
    computed: {
        ...mapGetters(['statusNameById']),

        nl2br() {
            return this.$filters.nl2br
        }
    },

    mounted() {
    },

    methods: {
        successMessage(message) {
            this.$swal.fire({
                title: "Successfull",
                icon: "success",
                text: `${message.toString().toUpperCase()}`,
                position: "top",
                timer: NoticeDuration,
            })
        },

        errorMessage(message) {
            this.$swal.fire({
                title: "Error",
                icon: "error",
                text: `${message.toString().toUpperCase()}`,
                position: "top",
                timer: NoticeDuration,
            })
        },

        alertMessage(title, message, type = 'danger') {
            return new Promise(resolve => {
                this.$swal.fire({
                    title: title,
                    icon: "warning",
                    text: `${message.toString().toUpperCase()}`,
                    onConfirm: () => {
                        resolve()
                    },
                })
            })
        },

        confirmMessage(title, message, confirmText) {
            return new Promise((resolve, reject) => {
                this.$swal.fire({
                    title: title,
                    text: message,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!',
                }).then((result) => {
                    console.log(result)
                    /* Read more about isConfirmed, isDenied below */
                    if (result.value) {
                        resolve()
                        this.$swal.fire(confirmText, '', 'success')
                    }
                })
            })
        },

        confirmMessageHtml(title, message, confirmText) {
            return new Promise((resolve, reject) => {
                this.$swal.fire({
                    title: title,
                    html: message,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!',
                }).then((result) => {
                    console.log(result)
                    /* Read more about isConfirmed, isDenied below */
                    if (result.value) {
                        resolve()
                        this.$swal.fire(confirmText, '', 'success')
                    }
                })
            })
        },

        customMessage(title, message, buttons) {
            return new Promise((resolve, reject) => {
                this.$oruga.modal.open(
                    {
                        parent: this,
                        component: CustomDialog,
                        hasModalCard: true,
                        trapFocus: true,
                        position: "top",
                        autoFocus: true,
                        scroll: "keep",
                        canCancel: ['escape', 'outside', 'button'],
                        props: { title, message, buttons },
                        events: { modalButtonClick: (e) => resolve(e) }
                    }
                )
            })
        },
        openModalComponent(components, props, buttons, events) {
            return new Promise((resolve, reject) => {
                this.$oruga.modal.open(
                    {
                        component: components,
                        hasModalCard: true,
                        trapFocus: true,
                        position: "top",
                        autoFocus: true,
                        scroll: "keep",
                        canCancel: ['escape', 'outside', 'button'],
                        props: { ...props, buttons: buttons },
                        events: { modalButtonClick: (e) => resolve(e), ...events }
                    }
                )
            })
        }
    }
})

axios.interceptors.request.use((config) => {
    if (Laravel.currentUser) {
        if (config.params === undefined) {
            config.params = {}
        }
        config.params.api_token = Laravel.currentUser.api_token
    }

    return config
})

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        let data = error.response.data

        if (error.response.status === 401 && error.response.data.error.errors[0].message != 'Invalid Credentials') {
            // window.location.replace('/login')
            console.log(error)
        }


        if (data.errors && data.errors.email) {
            data.errors.email.map((message) => {
                Vue.config.globalProperties.$swal.fire({
                    title: "Error",
                    icon: "error",
                    text: message,
                    position: "top",
                    timer: NoticeDuration,
                })
            })
        }

        if (data && data.message) {
            Vue.config.globalProperties.$swal.fire({
                title: "Error",
                icon: "error",
                text: data.message,
                position: "top",
            })
        }


        return Promise.reject(error)
    }
)

require('promise.prototype.finally').shim()


window.$ = window.jQuery = require('jquery')
window.axios = axios
window._ = require('lodash')
window.TWEEN = require('@tweenjs/tween.js')
window.moment = moment

Vue.config.globalProperties.$filters = filters

$.ajaxSetup({
    beforeSend: function () { }
})
